const urlSafeBase64 = require('./urlSafeBase64');
const { snapWidth } = require('./imageWidths');

const imageCrop = (src, width, height) => {
  if (!src) return;
  // Snap proportional (height-less) requests to the canonical ladder so they
  // share a derivative with every other surface showing the same image. When an
  // explicit height is given the caller wants a specific crop aspect, so leave
  // both dimensions untouched — snapping the width alone would distort the ratio
  // (e.g. 612x420 -> 800x420); the Worker still rounds to steps of 100 to dedup.
  if (!height) width = snapWidth(width);
  let imgUrl = src;

  // 3speak double-prefix cleanup
  if (
    imgUrl.match(
      /(https:\/\/ipfs-3speak\.b-cdn\.net\/ipfs\/)https:\/\/ipfs-3speak\.b-cdn\.net\/ipfs\/(?:.*)/,
    )
  ) {
    imgUrl = imgUrl.replace(/^https:\/\/ipfs-3speak\.b-cdn\.net\/ipfs\//, '');
  }

  const encodedURL = urlSafeBase64(imgUrl);

  return (
    'https://img.truvvle.com/?src=' +
    encodedURL +
    '&width=' +
    width +
    (height ? '&height=' + height : '')
  );
};

module.exports = imageCrop;
